import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { RootState } from '../../store/store'
import Loading from '../screens/pos/loading'

type ProtectedRoutesProps = {
    allowedRoles: string[] // e.g., ['admin', 'ventas']
}

const ProtectedRoutes = ({ allowedRoles }: ProtectedRoutesProps) => {

    const { isAuth, isLoading, user } = useSelector((state: RootState) => state.auth)

    if (isLoading) return <Loading />

    if (!isAuth) return <Navigate to="/pos/login" replace />

    if (user && !allowedRoles.includes(user.role)) {
        return <Navigate to="/unauthorized" replace />
    }

    return <Outlet />
}

export default ProtectedRoutes
